var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4633A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4269 25.7067H24.5469V35.3067C24.5469 36.72 26.3069 37.3867 27.2402 36.32L37.3336 24.8534C38.2136 23.8534 37.5069 22.2934 36.1736 22.2934H32.0536V12.6934C32.0536 11.28 30.2936 10.6134 29.3602 11.68L19.2669 23.1467C18.4002 24.1467 19.1069 25.7067 20.4269 25.7067Z",
    fill: "#F4633A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 14.3333H10C9.45333 14.3333 9 13.88 9 13.3333C9 12.7866 9.45333 12.3333 10 12.3333H19.3333C19.88 12.3333 20.3333 12.7866 20.3333 13.3333C20.3333 13.88 19.88 14.3333 19.3333 14.3333Z",
    fill: "#F4633A",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 35.6667H10C9.45333 35.6667 9 35.2134 9 34.6667C9 34.12 9.45333 33.6667 10 33.6667H18C18.5467 33.6667 19 34.12 19 34.6667C19 35.2134 18.5467 35.6667 18 35.6667Z",
    fill: "#F4633A",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25H10C9.45333 25 9 24.5467 9 24C9 23.4533 9.45333 23 10 23H14C14.5467 23 15 23.4533 15 24C15 24.5467 14.5467 25 14 25Z",
    fill: "#F4633A",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuick);
export default __webpack_public_path__ + "static/media/quick.cc3cb9c8f1f27a135a906be99a7fbdeb.svg";
export { ForwardRef as ReactComponent };